/**
 * @generated SignedSource<<5900d7328100888dc75660bb5b6640fb>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type RaffleUsecase = "CONSOLATION" | "EMPTY" | "PRIZE" | "%future added value";
export type raffleIndexQuery$variables = {
  hubMetaName: string;
};
export type raffleIndexQuery$data = {
  readonly hubMeta: {
    readonly hub: {
      readonly id: string;
      readonly raffle: {
        readonly ready: boolean;
        readonly reservations: ReadonlyArray<{
          readonly active: boolean;
          readonly id: string;
          readonly usecase: RaffleUsecase;
        }>;
      } | null | undefined;
    };
    readonly id: string;
    readonly name: string;
  };
};
export type raffleIndexQuery = {
  response: raffleIndexQuery$data;
  variables: raffleIndexQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "hubMetaName"
  }
],
v1 = [
  {
    "fields": [
      {
        "kind": "Variable",
        "name": "name",
        "variableName": "hubMetaName"
      }
    ],
    "kind": "ObjectValue",
    "name": "by"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "concreteType": "Hub",
  "kind": "LinkedField",
  "name": "hub",
  "plural": false,
  "selections": [
    (v2/*:: as any*/),
    {
      "alias": null,
      "args": null,
      "concreteType": "HubRaffle",
      "kind": "LinkedField",
      "name": "raffle",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "ready",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "RaffleReservation",
          "kind": "LinkedField",
          "name": "reservations",
          "plural": true,
          "selections": [
            (v2/*:: as any*/),
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "active",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "usecase",
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "raffleIndexQuery",
    "selections": [
      {
        "kind": "RequiredField",
        "field": {
          "alias": null,
          "args": (v1/*:: as any*/),
          "concreteType": "HubMeta",
          "kind": "LinkedField",
          "name": "hubMeta",
          "plural": false,
          "selections": [
            (v2/*:: as any*/),
            (v3/*:: as any*/),
            {
              "kind": "RequiredField",
              "field": (v4/*:: as any*/),
              "action": "THROW"
            }
          ],
          "storageKey": null
        },
        "action": "THROW"
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Operation",
    "name": "raffleIndexQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*:: as any*/),
        "concreteType": "HubMeta",
        "kind": "LinkedField",
        "name": "hubMeta",
        "plural": false,
        "selections": [
          (v2/*:: as any*/),
          (v3/*:: as any*/),
          (v4/*:: as any*/)
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "48e373e0a5e245667f400ae8177adb7a",
    "id": null,
    "metadata": {},
    "name": "raffleIndexQuery",
    "operationKind": "query",
    "text": "query raffleIndexQuery(\n  $hubMetaName: String!\n) {\n  hubMeta(by: {name: $hubMetaName}) {\n    id\n    name\n    hub {\n      id\n      raffle {\n        ready\n        reservations {\n          id\n          active\n          usecase\n        }\n      }\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "cbde7130e31e45330b86a7554f3d902c";

export default node;
